import React from 'react';
import PageTitle from '../components/PageTitle';
import ContactInfo from '../components/contact/ContactInfo';
/* import Map from '../components/contact/Map'; */
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <PageTitle
                    title="Get in Touch"
                    subtitle="We help individuals and businesses achieve their creative goals. you are the creative source, we are the creative force."
                />

                <section>
                    <div className="stg-row stg-bottom-gap">
                        <div className="stg-col-8">
                            <h2 data-split-appear="fade-up" data-unload="fade-up">Ready bring to life that creative idea? 🔥 Let's connect! 🤝</h2>
                        </div>
                        <div className="stg-col-4"></div>
                    </div>
                    <div className="stg-row stg-bottom-gap-l">
                        <div className="stg-col-6 stg-offset-6" data-appear="fade-up" data-delay="200" data-unload="fade-up">
                            <p>At infocolors, we believe in the power of collaboration and shared passion. We're not just a creative agency, we're your partners in reaaching your creative heights. So, whether you're brimming with ideas or just starting to spark, reach out and let's chat!</p>
                        </div>
                    </div>
                    <div className="infocolors-grid-3cols infocolors-parallax-media infocolors-m-grid-3cols stg-m-small-gap" data-stagger-appear="fade-up" data-delay="200" data-stagger-unload="fade-up">
                        <a href="img/inner-pages/contacts02.jpg" className="infocolors-lightbox-link" data-size="960x960">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/contacts02.jpg" alt="infocolors" width="960" height="960" />
                        </a>
                        <a href="img/inner-pages/contacts03.jpg" className="infocolors-lightbox-link" data-size="960x960">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/contacts03.jpg" alt="infocolors" width="960" height="960" />
                        </a>
                        <a href="img/inner-pages/contacts04.jpg" className="infocolors-lightbox-link" data-size="960x960">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/contacts04.jpg" alt="infocolors" width="960" height="960" />
                        </a>
                    </div>
                </section>

                <ContactInfo />
               {/*  <Map /> */}
                <ContactForm />
            </div>
        </main>
    );
};

export default ContactPage;
